import * as React from 'react';
import BCPagination from '../BCPagination';
import Style from './assets/css/style.scss';
import BCNavigator from './components/BCNavigator';
import {
	IBreadCrumbItemClickEventArgs,
	IBreadCrumbItemProps,
	IBreadCrumbNavigationClickEventArgs,
	IBreadCrumbNavigationProps,
	IBreadCrumbProps
} from './entities';

const BCBreadcrumb = (props: IBreadCrumbProps) => {
	const [, setOverflowIndex] = React.useState(0);
	React.useEffect(() => {
		props.onCreate?.();
	}, []);

	const getBreadcrumbItems = (): any[] => {
		const returnValue: any[] = [];
		if (props.items?.length) {
			props.items.forEach((item: IBreadCrumbItemProps, index: number) => {
				if (!item.isHidden) {
					returnValue.push({
						onClickCloseIcon: (ev: React.MouseEvent<HTMLElement>, item: any) =>
							onItemCloseClick({ data: item, senderArgs: ev, overflowIndex: index }),
						onClick: (ev: React.MouseEvent<HTMLElement>, item: any) =>
							onItemClick({ data: item, senderArgs: ev, overflowIndex: index }),
						...item
					});
				}
			});
		}
		return returnValue;
	};

	const renderPagination = () => {
		if (!getBreadcrumbItems().length) {
			return;
		}
		return (
			<BCPagination
				className={Style.breadcrumb}
				items={getBreadcrumbItems()}
			/>
		);
	};

	const renderNavigator = () => {
		if (props.disableNavigator) {
			return;
		}

		let isLeftNavigatorDisable = false;
		let isRightNavigatorDisable = false;

		if (props.items?.length > 1) {
			isLeftNavigatorDisable = props.items[0].isActive;
			isRightNavigatorDisable = props.items[props.items.length - 1].isActive;
		} else {
			isLeftNavigatorDisable = true;
			isRightNavigatorDisable = true;
		}

		return (
			<BCNavigator
				isLeftNavigatorDisable={isLeftNavigatorDisable}
				isRightNavigatorDisable={isRightNavigatorDisable}
				onClick={props.onNavigationItemClick}
				visible
				navigatorStyle={props.navigatorStyle}
			/>
		);
	};

	const onItemCloseClick = (item: IBreadCrumbItemClickEventArgs) => {
		item.senderArgs.persist();
		item.senderArgs.stopPropagation();
		if (props.onItemCloseClick) {
			props.onItemCloseClick(item);
		}
	};

	const onItemClick = (item: IBreadCrumbItemClickEventArgs) => {
		item.senderArgs.persist();
		item.senderArgs.stopPropagation();
		props.onItemClick?.(item);

		let index = 0;
		if (props.items.length < item.overflowIndex + 3) {
			index = props.items.length - 1;
		} else {
			index = item.overflowIndex + 3;
		}

		setOverflowIndex(index);
	};

	return (
		<>
			{!props.hideNav && renderNavigator()}
			<div className={[Style.breadcrumbContainer, 'breadcrumbContainer'].join(' ')}>
				{!props.hideItems && renderPagination()}
			</div>
		</>
	);
};
export default BCBreadcrumb;

export {
	IBreadCrumbProps,
	IBreadCrumbItemProps,
	IBreadCrumbNavigationProps,
	IBreadCrumbItemClickEventArgs,
	IBreadCrumbNavigationClickEventArgs
};
